import React from 'react';
import {StyledTabs} from './StyledTabs';
const Tabs = ({
  tabPaddingSize,
  ...rest
}) => {
  return (
    <StyledTabs $tabPaddingSize={tabPaddingSize} {...rest} />
  );
}
export default Tabs;
